// Copyright (c) 2025 Deere & Company

import actions from '../../actions-list';

export const closeDealerRecommendationModal = () =>

    dispatch => {

        document.body.classList.remove('warranty-modal-is-open');

        dispatch({
            type: actions.CLOSE_DEALER_RECOMMENDATION_MODAL
        });

    };

export const openDealerRecommendationModal = actionToTake =>

    dispatch => {

        document.body.classList.add('warranty-modal-is-open');

        dispatch({
            actionToTake,
            type: actions.OPEN_DEALER_RECOMMENDATION_MODAL
        });

    };



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/action-creators/dealer-recommendation-modal.js